import { Outlet } from "react-router-dom";

import { useSelectedOrganization } from "../../organizations/hooks";
import { Dashboard } from "../components";

export const DashboardContainer = () => {
    const { isNotSelected, loading } = useSelectedOrganization();
    return (
        <Dashboard isOrganizationNotSelected={isNotSelected || loading}>
            <Outlet />
        </Dashboard>
    );
};
